import { useEffect, useState } from 'react'

import { FlectoLanguages } from '../types/FlectoLanguages'

export function useBrowserLanguage(): FlectoLanguages {
  const [language, setLanguage] = useState<FlectoLanguages>(
    FlectoLanguages.DEFAULT
  )

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const locale = new Intl.Locale(navigator.language).language

      const languageMap: Record<string, FlectoLanguages> = {
        pt: FlectoLanguages.PT,
        en: FlectoLanguages.EN,
        es: FlectoLanguages.ES,
      }

      setLanguage(languageMap[locale] || FlectoLanguages.DEFAULT)
    }
  }, [])

  return language
}
